import type { SchemaProperty } from 'types/schema';
import type { SphereSectionSlotContext } from '../../sphereSectionSlots';

/** Visible properties in the section that a composed metric aspect contributed. */
export function composedMetricProperties(ctx: SphereSectionSlotContext): SchemaProperty[] {
  const metricAspects = new Set(
    (ctx.schemaType.aspects ?? []).filter((ref) => ref.isMetric).map((ref) => ref.systemName),
  );
  return ctx.properties.filter((p) => !!p.aspect_system_name && metricAspects.has(p.aspect_system_name));
}
